import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import Cookies from 'js-cookie';
import './Register.css';
import Navbar from './Navbar';
import Footer from './Footer';

const ACCESS_TOKEN_COOKIE = process.env.REACT_APP_ACCESS_TOKEN_COOKIE;
const REFRESH_TOKEN_COOKIE = process.env.REACT_APP_REFRESH_TOKEN_COOKIE;

const Register = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState(""); // Adicionar estado para o nome
  const [error, setError] = useState("");
  const [passwordStrength, setPasswordStrength] = useState(0); // Estado para armazenar a complexidade da senha
  const navigate = useNavigate();

  useEffect(() => {
    const inputs = document.querySelectorAll('.input-container input');
    inputs.forEach(input => {
      const errorMessage = input.parentElement.querySelector('.error-message');
      const label = input.nextElementSibling;

      input.addEventListener('focusout', () => {
        if (!input.value) {
          if (input && label && errorMessage) {
            input.style.borderColor = 'red';
            label.style.color = 'red';
            errorMessage.style.display = 'block';
            label.classList.add('label-error');
          }
        } else {
          if (errorMessage) {
            errorMessage.style.display = 'none';
          }
        }
      });

      input.addEventListener('input', () => {
        if (input.value) {
          if (input && label && errorMessage) {
            input.style.borderColor = '';
            label.style.color = '';
            errorMessage.style.display = 'none';
          }
        } else {
          if (input && label && errorMessage) {
            input.style.borderColor = 'red';
            label.style.color = 'red';
            errorMessage.style.display = 'block';
            label.classList.add('label-error');
          }
        }
      });
    });
  }, []);

  const calculatePasswordStrength = (password) => {
    let strength = 0;
    if (password.length >= 8) strength += 1;
    if (/\d/.test(password)) strength += 1;
    if (/[a-zA-Z]/.test(password)) strength += 1;
    return strength;
  };

  useEffect(() => {
    setPasswordStrength(calculatePasswordStrength(password));
  }, [password]);

  const handleRegister = async (e) => {
    e.preventDefault();
    setError("");

    if (password.length < 8 || !/\d/.test(password) || !/[a-zA-Z]/.test(password)) {
      setError("A senha deve ter no mínimo 8 caracteres alfanuméricos.");
      return;
    }

    const registerUser = async (attempt = 1) => {
      try {
        console.log('Register URI:', process.env.REACT_APP_REGISTER_URI);
        const response = await axios.post(process.env.REACT_APP_REGISTER_URI, { email, password, name }, { timeout: 11000 });
        console.error(response.data);
        if (response.data.success) {
          const accessTokenExpiration = new Date(new Date().getTime() + process.env.REACT_APP_JWT_EXPIRATION * 60 * 1000);
          const refreshTokenExpiration = new Date(new Date().getTime() + process.env.REACT_APP_JWT_REFRESH_EXPIRATION * 24 * 60 * 60 * 1000);

          Cookies.set(ACCESS_TOKEN_COOKIE, response.data.accessToken, { expires: accessTokenExpiration, secure: true, sameSite: 'Strict' });
          Cookies.set(REFRESH_TOKEN_COOKIE, response.data.refreshToken, { expires: refreshTokenExpiration, secure: true, sameSite: 'Strict' });
          navigate("/dashboard");
        } else {
          setError(response.data.message);
        }
      } catch (error) {
        console.error(`Erro ao registrar (tentativa ${attempt}):`, error);
        if (error.code === 'ERR_NETWORK' && attempt < 3) {
          setTimeout(() => registerUser(attempt + 1), 2000);
        } else if (error.code === 'ECONNABORTED') {
          setError("Erro de rede: a solicitação demorou muito para responder. Tente novamente.");
        } else {
          setError("Erro ao registrar. Tente novamente.");
        }
      }
    };

    registerUser();
  };

  const handleGoogleLogin = () => {
    const clientId = process.env.REACT_APP_CLIENT_ID;
    const redirectUri = process.env.REACT_APP_GOOGLE_CALLBACK_URI;
    const scope = "openid email profile";
    const responseType = "code";

    const googleAuthUrl = `https://accounts.google.com/o/oauth2/auth?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=${responseType}&scope=${scope}`;
    window.location.href = googleAuthUrl;
  };

  return (
    <div>
      <Navbar />
      <div className="register-container">
        <div className="logo-container">
          <img src="./logo.webp" alt="QR Code Brasil" />
        </div>
        <h1><span>Já tem uma conta? </span><a href="/login">Faça login</a></h1>
        <form onSubmit={handleRegister}>
          <div className="input-container">
            <input type="text" id="name" placeholder=" " value={name} onChange={(e) => setName(e.target.value)} required />
            <label htmlFor="name">Nome</label>
          </div>
          <div className="input-container">
            <input type="email" id="email" placeholder=" " value={email} onChange={(e) => setEmail(e.target.value)} required />
            <label htmlFor="email">Email</label>
          </div>
          <div className="input-container">
            <input type="password" id="password" placeholder=" " value={password} onChange={(e) => setPassword(e.target.value)} required />
            <label htmlFor="password">Senha</label>
            <div className="password-strength">
              <div className={`strength-bar ${passwordStrength >= 1 ? 'weak' : ''}`}></div>
              <div className={`strength-bar ${passwordStrength >= 2 ? 'medium' : ''}`}></div>
              <div className={`strength-bar ${passwordStrength >= 3 ? 'strong' : ''}`}></div>
            </div>
          </div>
          {error && <div className="error-message">{error}</div>}
          <button type="submit" className="register-button">Registrar</button>
        </form>
        <div className="separator">
          <hr />
          <span>OU</span>
          <hr />
        </div>
        <div className="google-login">
          <div onClick={handleGoogleLogin}>
            <img src="https://cdn1.iconfinder.com/data/icons/google-s-logo/150/Google_Icons-09-1024.png" alt="Google" />
          </div>
          <button onClick={handleGoogleLogin}>Entrar com uma conta do Google</button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Register;